import React from 'react';
import PropTypes from 'prop-types';

import Currency from '../../_utils/tools/currency';
import { totalQuantity, totalPrice } from './totalizing-mixin';
import Table from './summary-table';
import DropDown from '../../_common/dropdown';
import { DeliveryOption, PrintSize } from '../prop-types';

export default function Totaliser({ showQuantity, sizes, deliveryOption }) {
  const buttonText = (
    <React.Fragment>
      <span>Total: </span>
      {Currency.format(totalPrice(sizes, deliveryOption))}
    </React.Fragment>
  );

  return (
    <div className="total-price">
      {showQuantity && (
        <div className="total-price__quantity">Qty: {totalQuantity(sizes)}</div>
      )}
      <DropDown
        id="total-price"
        buttonId="total-price-trigger"
        buttonText={buttonText}>
        <Table deliveryOption={deliveryOption} sizes={sizes} />
      </DropDown>
    </div>
  );
}

Totaliser.propTypes = {
  showQuantity: PropTypes.bool,
  sizes: PropTypes.arrayOf(PrintSize),
  deliveryOption: DeliveryOption,
};

Totaliser.defaultProps = {
  showQuantity: false,
  sizes: [],
  deliveryOption: {},
};
